import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { business } from "@/config/business";
import { getWhatsAppUrl } from "@/lib/whatsapp";
import { trackEvent, EVENTS } from "@/lib/tracking";

/**
 * WhatsAppFloat — tombol mengambang WhatsApp.
 * Otomatis disembunyikan saat section lead-form terlihat, agar tidak
 * menutupi field formulir.
 */
export const WhatsAppFloat = () => {
  const [hidden, setHidden] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Muncul setelah scroll melewati hero
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    // Sembunyikan saat form terlihat
    const target = document.getElementById("lead-form");
    let observer;
    if (target) {
      observer = new IntersectionObserver(
        ([entry]) => setHidden(entry.isIntersecting),
        { threshold: 0.15 },
      );
      observer.observe(target);
    }
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (observer) observer.disconnect();
    };
  }, []);

  return (
    <a
      href={getWhatsAppUrl()}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent(EVENTS.WHATSAPP_CLICK, { source: "floating_button" })}
      data-testid="whatsapp-float"
      aria-label={`Chat WhatsApp ${business.whatsapp.display}`}
      aria-hidden={show && !hidden ? "false" : "true"}
      tabIndex={show && !hidden ? 0 : -1}
      className={`fixed bottom-5 right-5 z-40 flex items-center gap-3 rounded-full bg-[#25D366] py-3 pl-3 pr-4 text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.6)] transition-all duration-300 hover:bg-[#1eb85a] sm:bottom-6 sm:right-6 ${
        show && !hidden
          ? "translate-y-0 opacity-100"
          : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <span className="relative flex h-9 w-9 items-center justify-center">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/30" />
        <MessageCircle className="h-6 w-6" />
      </span>
      <span className="hidden text-sm font-bold sm:inline">Chat WhatsApp</span>
    </a>
  );
};

export default WhatsAppFloat;
